"use strict";

/* ========================================================================
 * Selection guides js
 * ======================================================================== */

import $ from "jquery";
import imagesLoaded from "../vendor/imagesloaded";
import "../vendor/waypoints";
import "../vendor/waypoints-sticky";

imagesLoaded.makeJQueryPlugin($);

class SelectionGuides {

	dom = {};

	createNavigationWaypoint() {
		new window.Waypoint({
			element: this.dom.$navigation,
			offset: function(){
				// Set offset based on window width
				const width = this.context.element.innerWidth;

				let offset = 19; // horizontal tablet
				if (width < 768) {
					offset = 55; // mobile
				} else if (width < 992) {
					offset = 65; // sticky mobile navigation
				}

				return offset;
			},
			handler: function(direction) {
				if (direction === "down") {
					this.element.addClass("waypoint-reached");
				} else {
					this.element.removeClass("waypoint-reached");
				}
			}
		});
	}

	handleBlockWaypoint($block, direction) {
		// Update navigation
		if ($block.updateBlockNavigation) {

			let $elem = $block;
			this.dom.$navigation.find("a").removeClass("selected");
			let id = null;

			if (direction === "down") {
				id = $block.attr("id");
			} else {
				const prevElem = $block.prev();
				$elem = prevElem;

				if (prevElem.length) {
					id = prevElem.attr("id");
				}
			}

			if (id) {
				const selectedItem = this.dom.$navigation.find('a[href="#'+id+'"]');
				if (selectedItem.length) {
					selectedItem.addClass("selected");

					// Update tablet / mobile nav label
					this.dom.$selectedLabel.text(selectedItem[0].innerText);
				}

				if (id !== this.dom.$fixedRecomProduct.attr("data-id")) {
					// update product recommendations
					this.dom.$fixedRecomProduct.attr("data-id", id);
					const $sectionProductRecom = $elem.find('.selection-guides__block-recom-products[data-id="'+id+'"]');

					if ($sectionProductRecom.length) {
						const label = $sectionProductRecom.find(".generic-dropdown__toggle-label").text();
						const img = $sectionProductRecom.find(".generic-dropdown__toggle-img img");
						const content = $sectionProductRecom.find(".generic-dropdown__menu").html();

						this.dom.$fixedRecomProductLabel.text(label);
						this.dom.$fixedRecomProductContent.html(content);

						if (img.length) {
							this.dom.$fixedRecomProductImg.html(img.clone());
						}
					}
				}
			}
		}

		// Sticky js classes
		if ($block.createSticky) {
			if (direction === "down") {
				$block.addClass("stuck");
			} else {
				$block.removeClass("stuck");
			}
		}
	}

	createBlockWaypoint($block) {
		const _context = this;
		const elemClass = $block.createSticky ? ".selection-guides__block-image-container" : ".selection-guides__block-image"; // Use image container as element so sticky wrapper can be used when needed

		// Create block start waypoint
		const waypointSettings = {
			element: $block.find(elemClass)[0],
			offset: 100,
			handler: function(direction) {
				_context.handleBlockWaypoint($block, direction);
			}
		};

		if (!$block.createSticky) {
			// if css position sticky is available (or we do not have and image), we do not need sticky js
			// Create regular waypoint for navigation
			new window.Waypoint(waypointSettings);
		} else {
			// Sticky waypoint for legacy browsers
			// Create end for waypoint stickyness
			new window.Waypoint({
				element: $block.find(".selection-guides__block-content")[0],
				offset: function(){
					// Calculate offset based on image height
					const contentHeight = this.element.clientHeight;
					const imgHeight = $block.find(".selection-guides__block-image img")[0].clientHeight; // We have already checked that image exists

					let diff = contentHeight - imgHeight;
					if (diff === 0 || diff < 0) { // Image and content are the same height
						diff = 100;
					} else { // Text content is taller than image
						diff = -diff + 100; // padding
					}

					return diff;
				},
				handler: function(direction) {
					if (direction === "down") {
						$block.addClass("stuck-bottom");
					} else {
						$block.removeClass("stuck-bottom");
					}
				}
			});

			// Create sticky waypoint (legacy browsers)
			new window.Waypoint.Sticky(waypointSettings);
		}
	}

	browserSupportsPositionSticky() {
		const prop = "position:";
		const value = "sticky";
		const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");

		const el = document.createElement("a");
		const mStyle = el.style;
		mStyle.cssText = prop + prefixes.join(value + ";" + prop).slice(0, - prop.length);

		return mStyle.position.indexOf(value) !== -1;
	}

	init() {
		/**
		 * Selection guides Block waypoints
		 */

		const $fixedRecomProduct = $(".selection-guides__fixed-recom-products");

		this.dom = {
			$html: $("html"),
			$pageContent: $(".site-content"),
			$blocks: $(".selection-guides__block"),
			$navigation: $(".selection-guides__parent-navigation"),
			$selectedLabel: $(".selection-guides__selected-nav-item-label"),
			$fixedRecomProduct: $fixedRecomProduct,
			$fixedRecomProductLabel: $fixedRecomProduct.find(".generic-dropdown__toggle-label"),
			$fixedRecomProductImg: $fixedRecomProduct.find(".generic-dropdown__toggle-img"),
			$fixedRecomProductContent: $fixedRecomProduct.find(".generic-dropdown__menu")
		};

		const _context = this;
		$(window).on("load", () => {
			// Check if browser supports position sticky
			const supportSticky = _context.browserSupportsPositionSticky();
			document.documentElement.classList.add(supportSticky ? "csspositionsticky" : "no-csspositionsticky");

			// Check if browser supports mix blend mode
			const blendmode = CSS.supports("mix-blend-mode", "multiply");
			document.documentElement.classList.add(blendmode ? "backgroundblendmode" : "no-backgroundblendmode");

			// When images have been loaded, create waypoints
			_context.dom.$pageContent.imagesLoaded(() => {
				// Create waypoint for navigation
				if (_context.dom.$navigation.length) {
					_context.createNavigationWaypoint();
				}

				$(_context.dom.$blocks.get().reverse()).each(function(i, block) {
					const $block = $(block);

					// createSticky: css position sticky not available, block image should be sticky && image can be found
					$block.createSticky = !supportSticky && $block.hasClass("selection-guides__block--sticky") && $block.find(".selection-guides__block-image img").length;
					// updateBlockNavigation: page has navigation for blocks
					$block.updateBlockNavigation = !!_context.dom.$navigation.length;

					// Create waypoint if needed for navigation or to make sticky for legacy browsers
					if ($block.updateBlockNavigation || $block.createSticky) {
						_context.createBlockWaypoint($block);
					}
				});
			});
		});
	}
}

export default new SelectionGuides();
